var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewPasswordModalIMage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 128,
    viewBox: "0 0 148 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_439_1097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 1,
    width: 110,
    height: 126
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9765 2.35829C82.47 0.901339 85.5551 0.901341 88.0486 2.35829L134.814 29.6838C137.269 31.1182 138.778 33.7478 138.778 36.5911V91.4089C138.778 94.2522 137.269 96.8818 134.814 98.3162L88.0486 125.642C85.5551 127.099 82.47 127.099 79.9765 125.642L33.2113 98.3162C30.7564 96.8818 29.2474 94.2522 29.2474 91.4089V36.5911C29.2474 33.7478 30.7564 31.1182 33.2113 29.6838L79.9765 2.35829Z",
    fill: "#0CAF60"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_439_1097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9765 2.35829C82.47 0.901339 85.5551 0.901341 88.0486 2.35829L134.814 29.6838C137.269 31.1182 138.778 33.7478 138.778 36.5911V91.4089C138.778 94.2522 137.269 96.8818 134.814 98.3162L88.0486 125.642C85.5551 127.099 82.47 127.099 79.9765 125.642L33.2113 98.3162C30.7564 96.8818 29.2474 94.2522 29.2474 91.4089V36.5911C29.2474 33.7478 30.7564 31.1182 33.2113 29.6838L79.9765 2.35829Z",
    fill: "#EDB42E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.264 26.6665H75.3689C72.7898 26.6665 70.699 28.7825 70.699 31.3928V100.78C70.699 103.39 72.7898 105.506 75.3689 105.506H176.264C178.843 105.506 180.934 103.39 180.934 100.78V31.3928C180.934 28.7825 178.843 26.6665 176.264 26.6665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.89 29.3467H78.7772C76.3922 29.3467 74.4587 31.3035 74.4587 33.7173V97.3354C74.4587 99.7492 76.3922 101.706 78.7772 101.706H172.89C175.275 101.706 177.208 99.7492 177.208 97.3354V33.7173C177.208 31.3035 175.275 29.3467 172.89 29.3467Z",
    fill: "#EDB42E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.119 104.763H66.0634C63.7533 104.763 61.8806 106.658 61.8806 108.996V109.454C61.8806 111.792 63.7533 113.687 66.0634 113.687H183.119C185.429 113.687 187.301 111.792 187.301 109.454V108.996C187.301 106.658 185.429 104.763 183.119 104.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.119 104.763H66.0634C63.7533 104.763 61.8806 106.658 61.8806 108.996V109.454C61.8806 111.792 63.7533 113.687 66.0634 113.687H183.119C185.429 113.687 187.301 111.792 187.301 109.454V108.996C187.301 106.658 185.429 104.763 183.119 104.763Z",
    fill: "url(#paint0_linear_439_1097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.624 104.844H112.179V107.489H137.624V104.844Z",
    fill: "url(#paint1_linear_439_1097)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_439_1097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.251 40.3824V80.2223C108.251 81.6152 107.705 82.9513 106.733 83.9377C105.762 84.9241 104.443 85.4802 103.067 85.4843H22.9341C22.2519 85.4843 21.5763 85.3481 20.9462 85.0835C20.316 84.8189 19.7436 84.4311 19.2617 83.9424C18.7798 83.4536 18.3978 82.8734 18.1378 82.2351C17.8777 81.5967 17.7446 80.9127 17.7461 80.2223V40.3824C17.7461 38.9899 18.2927 37.6544 19.2656 36.6697C20.2386 35.685 21.5582 35.1318 22.9341 35.1318H103.067C104.441 35.1349 105.759 35.6891 106.731 36.6733C107.702 37.6574 108.249 38.9912 108.251 40.3824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5918 84.4528L101.401 94.9333V82.1333L85.5918 84.4528Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9222 45.348C62.6886 45.4331 62.4315 45.4231 62.205 45.3202C61.9785 45.2173 61.8003 45.0295 61.7079 44.7963L60.7981 42.3498C60.538 41.6817 60.0285 41.1441 59.3798 40.8533C58.7311 40.5625 57.9953 40.5419 57.3316 40.7959C56.668 41.05 56.1299 41.5583 55.8337 42.2108C55.5376 42.8633 55.5072 43.6076 55.7492 44.2827L57.0086 47.6499C57.0288 47.7054 57.0439 47.7627 57.0537 47.8211H55.0612L53.9897 44.9561C53.5842 43.8123 53.6389 42.553 54.1419 41.4496C54.6449 40.3462 55.5561 39.4868 56.6791 39.0568C57.8022 38.6267 59.0472 38.6603 60.146 39.1502C61.2448 39.6402 62.1095 40.5474 62.5537 41.6764L63.4673 44.1191C63.5114 44.236 63.5323 44.3605 63.5288 44.4856C63.5252 44.6107 63.4974 44.7338 63.4467 44.848C63.3961 44.9622 63.3237 45.0651 63.2337 45.1509C63.1437 45.2367 63.0378 45.3037 62.9222 45.348Z",
    fill: "#EDB42E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8595 47.8438H53.5098V59.3913H65.8595V47.8438Z",
    fill: "url(#paint2_linear_439_1097)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8441 47.8213H58.0996V59.3688H65.8441V47.8213Z",
    fill: "url(#paint3_linear_439_1097)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3903 53.2315C59.3903 53.2315 58.1722 52.2042 59.2361 51.3291C60.3 50.454 61.4918 52.2803 60.364 53.2315L61.1572 55.3736H58.4805L59.3903 53.2315Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1372 63.3321H31.8056C30.464 63.3321 29.3785 64.4325 29.3785 65.7873V72.5065C29.3785 73.8613 30.464 74.9617 31.8056 74.9617H93.1372C94.4787 74.9617 95.5642 73.8613 95.5642 72.5065V65.7873C95.5642 64.4325 94.4787 63.3321 93.1372 63.3321Z",
    fill: "white",
    stroke: "#CBD5E0",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9255 71.2663C40.2274 71.2663 41.2827 70.1982 41.2827 68.8807C41.2827 67.5632 40.2274 66.4951 38.9255 66.4951C37.6237 66.4951 36.5684 67.5632 36.5684 68.8807C36.5684 70.1982 37.6237 71.2663 38.9255 71.2663Z",
    fill: "#EDB42E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2869 71.2663C46.5887 71.2663 47.644 70.1982 47.644 68.8807C47.644 67.5632 46.5887 66.4951 45.2869 66.4951C43.985 66.4951 42.9297 67.5632 42.9297 68.8807C42.9297 70.1982 43.985 71.2663 45.2869 71.2663Z",
    fill: "#EDB42E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6423 71.2663C52.9442 71.2663 53.9995 70.1982 53.9995 68.8807C53.9995 67.5632 52.9442 66.4951 51.6423 66.4951C50.3405 66.4951 49.2852 67.5632 49.2852 68.8807C49.2852 70.1982 50.3405 71.2663 51.6423 71.2663Z",
    fill: "#EDB42E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9978 71.2663C59.2996 71.2663 60.355 70.1982 60.355 68.8807C60.355 67.5632 59.2996 66.4951 57.9978 66.4951C56.696 66.4951 55.6406 67.5632 55.6406 68.8807C55.6406 70.1982 56.696 71.2663 57.9978 71.2663Z",
    fill: "#EDB42E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8591 71.2663C66.161 71.2663 67.2163 70.1982 67.2163 68.8807C67.2163 67.5632 66.161 66.4951 64.8591 66.4951C63.5573 66.4951 62.502 67.5632 62.502 68.8807C62.502 70.1982 63.5573 71.2663 64.8591 71.2663Z",
    fill: "#EDB42E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2126 71.2663C72.5145 71.2663 73.5698 70.1982 73.5698 68.8807C73.5698 67.5632 72.5145 66.4951 71.2126 66.4951C69.9108 66.4951 68.8555 67.5632 68.8555 68.8807C68.8555 70.1982 69.9108 71.2663 71.2126 71.2663Z",
    fill: "#EDB42E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5681 71.2663C78.8699 71.2663 79.9253 70.1982 79.9253 68.8807C79.9253 67.5632 78.8699 66.4951 77.5681 66.4951C76.2663 66.4951 75.2109 67.5632 75.2109 68.8807C75.2109 70.1982 76.2663 71.2663 77.5681 71.2663Z",
    fill: "#EDB42E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9333 71.2663C85.2352 71.2663 86.2905 70.1982 86.2905 68.8807C86.2905 67.5632 85.2352 66.4951 83.9333 66.4951C82.6315 66.4951 81.5762 67.5632 81.5762 68.8807C81.5762 70.1982 82.6315 71.2663 83.9333 71.2663Z",
    fill: "#EDB42E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9192 31.407C20.5536 31.4068 20.196 31.2987 19.8902 31.096C19.5844 30.8932 19.3436 30.6046 19.1974 30.2655L15.1372 20.7992C15.0384 20.5699 14.9853 20.3231 14.9808 20.073C14.9763 19.8229 15.0205 19.5743 15.1109 19.3415C15.2013 19.1086 15.3362 18.8961 15.5077 18.716C15.6793 18.5359 15.8843 18.3918 16.1109 18.2919C16.3375 18.192 16.5813 18.1382 16.8284 18.1336C17.0756 18.1291 17.3212 18.1738 17.5513 18.2653C17.7813 18.3568 17.9913 18.4933 18.1692 18.6669C18.3472 18.8406 18.4896 19.048 18.5883 19.2773L22.6448 28.7474C22.7697 29.0371 22.8213 29.3538 22.795 29.6688C22.7687 29.9838 22.6652 30.2872 22.4939 30.5515C22.3226 30.8159 22.089 31.0329 21.814 31.1829C21.5391 31.3329 21.2315 31.4112 20.9192 31.4108V31.407Z",
    fill: "#EDB42E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.69278 44.3849C2.19424 44.4016 1.70959 44.2171 1.34544 43.8721C0.981295 43.5271 0.767476 43.0499 0.751024 42.5453C0.734573 42.0408 0.916837 41.5503 1.25772 41.1817C1.5986 40.8132 2.07018 40.5968 2.56871 40.5801L12.738 39.8915C13.2365 39.8577 13.7279 40.0257 14.1041 40.3585C14.4802 40.6914 14.7103 41.1619 14.7437 41.6664C14.7771 42.1709 14.6111 42.6683 14.2822 43.0489C13.9533 43.4296 13.4884 43.6624 12.9899 43.6963L2.81684 44.3811L2.69278 44.3849Z",
    fill: "#EDB42E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5094 35.0218C13.1378 35.0206 12.775 34.9066 12.4681 34.6946L4.0206 28.8961C3.61655 28.6091 3.34027 28.1728 3.25141 27.6813C3.16256 27.1899 3.26828 26.6829 3.54573 26.2697C3.82318 25.8565 4.25009 25.5703 4.73426 25.473C5.21843 25.3757 5.721 25.475 6.13341 25.7495L14.5658 31.548C14.8974 31.777 15.1479 32.1074 15.2805 32.4909C15.4131 32.8743 15.4209 33.2907 15.3029 33.679C15.1848 34.0673 14.947 34.4071 14.6243 34.6488C14.3015 34.8904 13.9109 35.0211 13.5094 35.0218Z",
    fill: "#EDB42E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_439_1097",
    x: 5.74609,
    y: 27.1318,
    width: 122.505,
    height: 91.8013,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_439_1097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_439_1097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_439_1097",
    x1: 124.72,
    y1: 114.011,
    x2: 124.217,
    y2: 95.6662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55C790",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#55C790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_439_1097",
    x1: 124.964,
    y1: 98.8954,
    x2: 124.793,
    y2: 118.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CAF60",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0CAF60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_439_1097",
    x1: 76.9762,
    y1: 42.597,
    x2: 42.0604,
    y2: 64.3252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CAF60",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0CAF60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_439_1097",
    x1: 75.1863,
    y1: 45.1732,
    x2: 48.5027,
    y2: 61.7779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CAF60",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0CAF60"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPasswordModalIMage);
export default __webpack_public_path__ + "static/media/newPasswordModalIMage.76377222acb3f9f9a71e015e94e147f3.svg";
export { ForwardRef as ReactComponent };